import {
  SECRET_KEY,
  SP_CLIENT_ID_DEV,
  SP_CLIENT_ID_LIVE,
  SP_CLIENT_ID_STAGE,
} from "./constants";

// Helper to encode Base64
function base64Encode(str) {
  return btoa(
    new TextEncoder()
      .encode(str)
      .reduce((data, byte) => data + String.fromCharCode(byte), ""),
  );
}

// Helper to decode Base64
function base64Decode(str) {
  const binary = atob(str);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new TextDecoder().decode(bytes);
}

// XOR encryption
export function encrypt(text) {
  let result = "";
  for (let i = 0; i < text.length; i++) {
    const charCode =
      text.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length);
    result += String.fromCharCode(charCode);
  }
  return base64Encode(result);
}

// XOR decryption
export function decrypt(encodedText) {
  const decoded = base64Decode(encodedText);
  let result = "";
  for (let i = 0; i < decoded.length; i++) {
    const charCode =
      decoded.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length);
    result += String.fromCharCode(charCode);
  }
  return result;
}
export function isValidPassword(password) {
  const pattern =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!~`@#$%^&*()<=\>?"+'/:;,\-{}_|\[\]]).{8,}$/;
  return pattern.test(password);
}

//wrap chart text
export function wrapChartCharacters(text, maxLength = 24) {
  const result = [];

  if (text) {
    while (text.length > maxLength) {
      // Find the last space before or at the 24th character
      let splitIndex = text.lastIndexOf(" ", maxLength);
      if (splitIndex === -1) splitIndex = maxLength; // fallback if no space found

      result.push(text.slice(0, splitIndex));
      text = text.slice(splitIndex).trim(); // remove leading space
    }

    if (text.length) {
      result.push(text); // add remaining text
    }

    return result;
  } else {
    return result;
  }
}

export function sampleSizeSymbolCheck(value, type) {
  if (type === "products") {
    if (value > 34 && value < 50) {
      return "^";
    } else if (value < 35) {
      return "*";
    } else {
      return "";
    }
  }

  if (type === "survey") {
    if (value > 99 && value < 151) {
      return "^";
    } else if (value < 100) {
      return "*";
    } else {
      return "";
    }
  }
}

export const isEmptyCheck = (value) => {
  return value === null || value === "" || value === undefined;
};

export const getClientIdFromUrl = (hostname) => {
  if (hostname.includes("app-dev.panel.qualsights.com")) {
    return SP_CLIENT_ID_DEV;
  } else if (hostname.includes("app-stage.panel.qualsights.com")) {
    return SP_CLIENT_ID_STAGE;
  } else if (
    hostname.includes("app.panel.qualsights.com") ||
    hostname.includes("platform.usesights.com") ||
    hostname.includes("usesights.qualsights.com")
  ) {
    return SP_CLIENT_ID_LIVE;
  } else {
    return SP_CLIENT_ID_STAGE;
  }
};

export const getEnvFromUrl = (hostname) => {
  if (hostname.includes("app-dev.panel.qualsights.com")) {
    return "development";
  } else if (hostname.includes("app-stage.panel.qualsights.com")) {
    return "staging";
  } else if (
    hostname.includes("app.panel.qualsights.com") ||
    hostname.includes("platform.usesights.com") ||
    hostname.includes("usesights.qualsights.com")
  ) {
    return "clients";
  } else {
    return "development";
  }
};

export const getRandomizeBlockItems = (taskQuestion) => {
  const getRandomizeBlocksData = taskQuestion.length
    ? taskQuestion.filter((tq) => tq?.block_id || tq?.bId)
    : [];

  // get unique selected blocks from the items
  const getRandomizeBlocks = getRandomizeBlocksData?.length
    ? Array.from(
        new Map(
          getRandomizeBlocksData.map((item) => [
            `${item.block_id}-${item.bId}`,
            item,
          ]),
        ).values(),
      )
    : [];

  return getRandomizeBlocks;
};

export const getRandomizeSelectedBlockItems = (taskQuestion) => {
  const getRandomizeBlocksData = taskQuestion.length
    ? taskQuestion.filter((tq) => tq?.isSelected && (tq?.block_id || tq?.bId))
    : [];

  // get unique selected blocks from the items
  const getRandomizeBlocks = getRandomizeBlocksData?.length
    ? Array.from(
        new Map(
          getRandomizeBlocksData.map((item) => [
            `${item.block_id}-${item.bId}`,
            item,
          ]),
        ).values(),
      )
    : [];

  return getRandomizeBlocks;
};

export const checkIsSameBlock = (tempItem, shuffleToItem) => {
  if (tempItem?.block_id || tempItem?.bId) {
    if (!shuffleToItem?.block_id && !shuffleToItem?.bId) {
      return false;
    }
    if (shuffleToItem?.bId !== tempItem?.bId) {
      return false;
    }
  }
  return true;
};
